import { RouletteColorResult } from 'types/tables';

export const getRouletteColor = (value: number): RouletteColorResult => {
  if (value === 0) {
    return RouletteColorResult.GREEN;
  }

  const redNumbers = new Set([1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36]);

  return redNumbers.has(value) ? RouletteColorResult.RED : RouletteColorResult.BLACK;
};
